import { render } from "./UnfriendlyCountryStatuses.vue?vue&type=template&id=7f5b1937&scoped=true"
import script from "./UnfriendlyCountryStatuses.vue?vue&type=script&lang=js"
export * from "./UnfriendlyCountryStatuses.vue?vue&type=script&lang=js"

import "./UnfriendlyCountryStatuses.vue?vue&type=style&index=0&id=7f5b1937&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5b1937"]])

export default __exports__